// extracted by mini-css-extract-plugin
export default {"warning":"hCsU6e2cib","primaryAlternateColorPlaceholder":"c2AsomJoiQ"};